import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";

import {otherOption} from "../../../constants/otherOption";
import {HomeMatchAmplitudeTracker} from "../../tracking/amplitude/home_match_amplitude_tracker";
import {usePostUserHomeMatchResignationSurveyMutation} from "../../user/api/user_api";
import {hitGtmHomeMatchResignationConfirmation} from "../../user/tracking/hit_gtm_home_match_subscriptions";
import {HomeMatchResignationSurveyValues} from "../components/home_match_resignation_survey/HomeMatchResignationSurvey";

interface IOptions {
    disableHomeMatch: () => Promise<unknown>;
    onError: () => void;
    onSuccess: () => void;
}

const getReasonType = (selectedAnswer?: string) => (selectedAnswer === otherOption.value ? 5 : Number(selectedAnswer));

export const useHomeMatchResignationSurveySubmit = (options: IOptions) => {
    const {disableHomeMatch, onError, onSuccess} = options;

    const [postUserHomeMatchResignationSurvey] = usePostUserHomeMatchResignationSurveyMutation();

    return async (values: HomeMatchResignationSurveyValues) => {
        try {
            const reason = getReasonType(values.selectedAnswer);

            hitGtmHomeMatchResignationConfirmation(values.selectedAnswer);
            HomeMatchAmplitudeTracker.unsubscribeSurvey({selectedAnswer: values.selectedAnswer, ownAnswer: values.ownAnswer});

            await disableHomeMatch();
            await postUserHomeMatchResignationSurvey({
                reason_description: values.ownAnswer,
                reason_type: reason || null
            });

            onSuccess();
        } catch (error) {
            notifyBugsnagClient(new Error("Failed to disable HomeMatch service"), "", JSON.stringify(error));
            onError();
        }
    };
};
import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";

import {otherOption} from "../../../constants/otherOption";
import {HomeMatchAmplitudeTracker} from "../../tracking/amplitude/home_match_amplitude_tracker";
import {usePostUserHomeMatchResignationSurveyMutation} from "../../user/api/user_api";
import {hitGtmHomeMatchResignationConfirmation} from "../../user/tracking/hit_gtm_home_match_subscriptions";
import {HomeMatchResignationSurveyValues} from "../components/home_match_resignation_survey/HomeMatchResignationSurvey";

interface IOptions {
    disableHomeMatch: () => Promise<unknown>;
    onError: () => void;
    onSuccess: () => void;
}

const getReasonType = (selectedAnswer?: string) => (selectedAnswer === otherOption.value ? 5 : Number(selectedAnswer));

export const useHomeMatchResignationSurveySubmit = (options: IOptions) => {
    const {disableHomeMatch, onError, onSuccess} = options;

    const [postUserHomeMatchResignationSurvey] = usePostUserHomeMatchResignationSurveyMutation();

    return async (values: HomeMatchResignationSurveyValues) => {
        try {
            const reason = getReasonType(values.selectedAnswer);

            hitGtmHomeMatchResignationConfirmation(values.selectedAnswer);
            HomeMatchAmplitudeTracker.unsubscribeSurvey({selectedAnswer: values.selectedAnswer, ownAnswer: values.ownAnswer});

            await disableHomeMatch();
            await postUserHomeMatchResignationSurvey({
                reason_description: values.ownAnswer,
                reason_type: reason || null
            });

            onSuccess();
        } catch (error) {
            notifyBugsnagClient(new Error("Failed to disable HomeMatch service"), "", JSON.stringify(error));
            onError();
        }
    };
};
